import { Badge } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const PAGE = 'features:storefront_widgets.pages.storefront_widgets_page' satisfies I18nPrefix;

export function InteractiveExampleLink({ link }: { link: string }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="relative inline-flex rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-platform-primary focus-visible:ring-offset-2"
    >
      <Badge variant="green" icon="view" interactive>
        {t(`${PAGE}.pdp.example_link`)}
      </Badge>
    </a>
  );
}
